export default {
  APP_NAME: "Shree Ratn",
  COMPANY_NAME: "Shree Ratn",
  COMPANY_ADDRESS: "1234 Example Street, City, Country",
};
